<template>
  <div class="login-wrapper">
    <div class="login-box">
      <div class="header">
        <img src="../../assets/logo.png" alt="logo" class="logo" />
        <h1 class="title">开发者端</h1>
        <p class="subtitle">欢迎回来，请登录您的账号</p>
      </div>

      <el-form :model="loginForm" :rules="rules" ref="loginFromRef" class="login-form">
        <el-form-item prop="email">
          <el-input 
            prefix-icon="el-icon-message" 
            v-model="loginForm.email" 
            placeholder="请输入邮箱/用户名"
            >
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
            >
          </el-input>
        </el-form-item>

        <el-form-item prop="code">
          <div class="captcha-container">
            <el-input 
              prefix-icon="el-icon-key" 
              v-model="loginForm.code" 
              placeholder="验证码"
              class="captcha-input"
              >
            </el-input>
            <div class="captcha-img" v-html="code" @click="getCode" title="点击切换验证码"></div>
          </div>
        </el-form-item>

        <div class="action-links">
          <router-link to="/forget">忘记密码？</router-link>
          <router-link to="/register" class="reg-link">注册新账号</router-link>
        </div>

        <el-form-item>
          <el-button type="primary" class="login-btn" @click="login" :loading="loading">
            立即登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
        code: "",
        sign:""
      },
      code:"",
      rules: {
        email: [
          { required: true, message: "请输入用户名", trigger: ["blur", "change"] },
          { min: 5, max: 40, message: "长度在 5 到 40 个字符", trigger: ["blur", "change"]},
        ],
        password: [
          { required: true, message: "请输入密码", trigger: ["blur", "change"] },
          { min: 5, max: 16, message: "长度在 5 到 16 个字符", trigger: ["blur", "change"]},
        ],
        code: [{ required: true, message: "请输入验证码", trigger: ["blur", "change"] }],
        l:null
      },
      loading:false
    };
  },
  created(){
    this.loadLoginInfo()
    this.getCode()
    this.goHome()
    // if(window.sessionStorage.getItem('token')){
    //   this.$router.push('welcome')
    // }
  },
  methods: {
    // reset() {
    //   /**
    //    * 需要表单重置
    //    * 并且需要移除校验结果
    //    */
    //   // this.loginForm.email = "";
    //   // this.loginForm.password = "";
    //   this.$refs.loginFromRef.resetFields();
    // },
    loadLoginInfo() {
      const savedUsername = localStorage.getItem('email')
      this.cachedPwd = localStorage.getItem('pwd')
      this.l = localStorage.getItem('l')
      if (savedUsername) {
        this.loginForm.email = savedUsername
      }
      if (this.cachedPwd && this.l) {
        this.loginForm.password = '*'.repeat(Number(this.l))
      }
    },
    async goHome(){
      // console.log("检测免登录");
      const token = window.localStorage.getItem('token')
      // console.log("localStorage：token:",token);
      if (token) {
        window.sessionStorage.setItem("token", token);
        const res = await this.$http.post("/account/info");
        console.log("-----------免登录res:",res);
        if (res.data.meta.status === -3 && res.data.meta.msg == "无效的token.") {
          window.localStorage.setItem('token', '');
          window.sessionStorage.clear();
          this.$router.push('/login')
          return this.$notify.error({title: '错误401', message: "无效的token"});
        }else if(res.data.meta.status === -5){
          window.localStorage.setItem('token', '');
          window.sessionStorage.clear();
          this.$router.push('/login')
          return this.$notify.error({title: '错误401', message: "登录状态已失效"});
        }else if(res.data.meta.status === -6){
          console.log("去充值页面");
          window.sessionStorage.setItem('email',res.data.data.email)
          window.sessionStorage.setItem('shareId',res.data.data.shareId)
          this.$router.push('/recharge')
          alert('套餐已过期，请充值\n充值成功后，请在页面右上角账号处进行退出登录\n重新登录即可\n如有问题请加管理QQ：58346871')
        }else if(res.data.meta.status === -7){
          console.log("进入主页");
          this.$router.push("/welcome");
          window.sessionStorage.setItem('email',res.data.data.email)
          window.sessionStorage.setItem('shareId',res.data.data.shareId)
          alert('套餐即将到期(还剩'+res.data.meta.msg+')，\n如有问题请加管理QQ：58346871')
        }else{
          console.log("进入主页");
          this.$router.push("/welcome");
          window.sessionStorage.setItem('email',res.data.data.email)
          window.sessionStorage.setItem('shareId',res.data.data.shareId)
        }
      }
    },
    login() {
      this.$refs.loginFromRef.validate(async (value) => {
        if (!value) {
          return this.$message.error("账号有问题");
        } else {
          this.loading = true;
          this.l = this.loginForm.password.length
          let submitPwd = this.loginForm.password
          if (this.isPureAsterisk(submitPwd) && this.cachedPwd) {
            submitPwd = this.cachedPwd
          } else {
            submitPwd = CryptoJS.MD5(submitPwd).toString(CryptoJS.enc.Hex)
          }
          const res = await this.$http.post("login", {
                                              email: this.loginForm.email,
                                              password: submitPwd,
                                              code: this.loginForm.code,
                                              sign:this.loginForm.sign
                                            });
          window.localStorage.setItem('email', this.loginForm.email)
          window.localStorage.setItem('pwd', submitPwd)
          window.localStorage.setItem('l', this.l)
          if (res.data.meta.status !== 200) {
            this.getCode()
            this.loading = false;
            return this.$message.error(res.data.meta.msg);
          } else {
            /**
             * 登陆成功 1.需要将token保存本地 sessionStorage
             *         2.通过编程式导航跳转到后台主页
             * sessionStorage 会话结束就会清空.所以很适合保存token
             */
            window.sessionStorage.setItem("token", res.data.data.token);
            window.sessionStorage.setItem('email',res.data.data.result.email)
            window.sessionStorage.setItem('shareId',res.data.data.result.shareId)
            window.sessionStorage.setItem('role','developer')
            window.localStorage.setItem('token', res.data.data.token)
            //把数据传到vuex
            this.$store.commit('getShareMsg',res.data.data.result.shareId)
            this.$store.commit('getAccount',res.data.data.result.email)
            this.$router.push("/welcome");
            this.loading = false;
            return this.$message.success("登陆成功");
          }
        }
      });
    },
    async getCode(){
      //this.imgSrc = this.imgSrc+Date.parse(new Date())
      let result = await this.$http.get('getcode?' + Date.parse(new Date()))
      this.code = result.data.img
      this.loginForm.sign = result.data.sign
      //console.log('this.loginForm.sign',this.loginForm.sign);
      //console.log('result.data',result.data);
    },
    isPureAsterisk(str) {
      if (!str) return false;
      const reg = /^[*]+$/;
      return reg.test(str);
    },
    changeInput(e){
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="less" scoped>
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.login-box {
  width: 380px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  box-sizing: border-box;


  &:hover {
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  }
}

.header {
  text-align: center;
  margin-bottom: 30px;
  .logo{
    widows: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  .title {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
    font-weight: 600;
  }
  .subtitle {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
  }
}

.captcha-container {
  display: flex;
  gap: 12px;
  align-items: center;

  .captcha-input {
    flex: 1;
  }
}

.captcha-container {
  display: flex;
  gap: 12px;
  .captcha-input { flex: 1; }
  .captcha-img {
    flex: 0 0 110px;
    height: 40px;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    /deep/ div, /deep/ svg {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.action-links {
  text-align: right;
  margin: -10px 0 20px 0;
  a {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }
}

.submit-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  border-radius: 8px;
  letter-spacing: 2px;
}

.action-links {
  display: flex;
  justify-content: space-between;
  margin: -10px 0 20px 0;
  
  a {
    font-size: 13px;
    color: #606266;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #409eff;
    }
  }

  .reg-link {
    color: #409eff;
    font-weight: 500;
  }
}

.login-btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  letter-spacing: 2px;
  border-radius: 8px;
}

.login_container {
  background-color: #2b4b6b;
  height: 100%;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items:center;/*垂直居中*/
  a {
    text-decoration: none;
    color: #409eff;
    font-size: 15px;
  }
  .login-logo {
    height: 130px;
    width: 130px;
    border-radius: 50%;
    border: 1px solid #eee;
    overflow: hidden;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -80%);
    z-index: 1;
    img {
      height: 100%;
      width: 100%;
      background-color: #eee;
    }
  }

  .el-form {
    height: 390px;
    background-color: #fff;
    border-top: 1px solid;
    border-radius: 5px;
    padding: 0 20px;
    .form-content {
      // margin-top: 80px;
      .info {
        margin-top: -4px;
        display: flex;
        justify-content: space-between;
      }
      .userfram{
        // margin-top: 80px;
      }
    }
    .el-form-item {
      margin-top: 30px;
      .left,
      .code {
        float: left;
        // width: 135px;
        width: 45%;
        height: 40px;
        img {
          // border: 1px solid #eee;
          width: 100%;
          height: 100%;
          // margin-left: 55px;
        }
        div {
          width: 100%;
          height: 100%;
          text-align: center;
          vertical-align: -9px;
          
        }
      }
      .el-button {
        float: right;
        margin-left: 20px;
        width: 100%;
        margin-top: -15px;
      }
    }
    .codefram{
      margin-top: 8px;
    }
  }
  h2{
    margin-top: 25px;
    margin-bottom: 0;
    text-align: center;
  }
}

.title{
  margin-top: 10px;
  text-align: center;
  img {
    width: 50px;
    height: 50px;
    vertical-align: -13px;
  }
  h1{
    display: inline;
    margin-left: 20px;
  }
}
  
/* 移动端适配策略：小于 768px */
@media screen and (max-width: 768px) {
  /deep/ .el-input__inner {
    font-size: 16px !important;
  }
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 15%;
  }
  .login-box {
    width: 100%;
    max-width: 100%;
    box-shadow: none;
    padding: 20px;
  }
}

</style>